const tags = [
  { id: "tag_english", name: "english", type: "language", productCount: 3 },
  { id: "tag_apparel", name: "apparel", type: "keyword", productCount: 2 },
  { id: "tag_drinkware", name: "drinkware", type: "keyword", productCount: 1 },
  { id: "tag_evergreen", name: "evergreen", type: "keyword", productCount: 1 },
  { id: "tag_gift", name: "gift", type: "searchable", productCount: 1 },
  { id: "tag_clearance", name: "clearance", type: "internal", productCount: 1 },
];

export default tags;
